document.addEventListener("DOMContentLoaded", function () {
  // Splide Carousel Setup
  let splideVideoReels = new Splide(".splide-video-reels-animated-heading", {
    perPage: 3,
    gap: 24,
    focus: "left",
    arrows: false,
    pagination: false,
    breakpoints: {
      990: {
        perPage: 2.3,
        perMove: 1,
      },
      768: {
        perPage: 1.3,
        perMove: 1,
      },
    },
  });

  // Defer all ScrollTriggers to window load
  window.addEventListener("load", function () {
    splideVideoReels.mount(); // mount after layout is ready

    // Background color transitions
    gsap.fromTo(
      [".index .video-reels-animated-heading"],
      { backgroundColor: "#10120f" },
      {
        backgroundColor: "#fff",
        force3D: true,
        scrollTrigger: {
          trigger: ".index .word-visible",
          start: "top bottom",
          end: "top 10%",
          toggleActions: "play none none reverse",
        },
      }
    );

    // Refresh triggers in case of font/layout shifts
    // ScrollTrigger.refresh();
  });

  // Play & Pause Button Functionality
  document.querySelectorAll(".splide__slide").forEach((slide) => {
    const video = slide.querySelector("video");
    const playBtn = slide.querySelector(".play-btn");
    const pauseBtn = slide.querySelector(".pause-btn");

    if (video && playBtn && pauseBtn) {
      playBtn.addEventListener("click", function () {
        video.play();
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
      });

      pauseBtn.addEventListener("click", function () {
        video.pause();
        pauseBtn.style.display = "none";
        playBtn.style.display = "block";
      });

      pauseBtn.style.display = "none";
    }
  });
});
